import { Routes, Route } from "react-router-dom";
import RecipientTypesList from "./RecipientTypesList";

export default function RecipientTypesPage() {
    return (
        <Routes>
            <Route path="/" element={<RecipientTypesList />}/>
        </Routes>
    )
}